
export const formatDate = (date: Date): string => {
    const now = new Date()

    const minute = 60 * 1000

    // @ts-ignore
    const elapsed = now - date

    if (elapsed <= minute) {
        return `A few moments ago`
    }
    
    if (elapsed <= 60 * minute) {
        return `${Math.round(elapsed / minute)} minutes ago`
    }

    if (elapsed <= 24 * 60 * minute) {
        return `${Math.round(elapsed / (60 * minute))} hours ago`
    }

    if (elapsed <= 30 * 24 * 60 * minute) {
        return `${Math.round(elapsed / (24 * 60 * minute))} days ago`
    }

    if (elapsed <= 366 * 24 * 60 * minute) {
        return `${Math.round(elapsed / (30 * 24 * 60 * minute))} months ago`
    }

    return `${Math.round(elapsed / (365 * 24 * 60 * minute))} years ago`
}
